import { BoundaryRingSections } from "./EditBoundary";
import { DeepPartial } from "portal/utils/objects";
import { Zone as ZoneType } from "protos/farm/farm";
import React, { FC } from "react";

interface ZoneProps {
  zone: ZoneType;
  updateZone: (newZone: DeepPartial<ZoneType>) => void;
}

export const Zone: FC<ZoneProps> = ({ zone }: ZoneProps) => (
  <div className="flex flex-col">
    <BoundaryRingSections zone={zone} />
  </div>
);
